<script>
  export let video
  export let last
  let div

  import {afterUpdate, createEventDispatcher, onMount, tick} from 'svelte';
  import {fade} from 'svelte/transition';
  import { sidebarToggled } from "./Utils/stores";
  import {update_video} from "./Utils/RouterUtils.svelte"
  const dispatch = createEventDispatcher();

  function videoClicked() {
      dispatch('video-clicked');
  }
  
  function toggle_sidebar() {
    if(window.innerWidth < 768) {
      if(sidebarState) {
        sidebarToggled.update(sidebarToggled => false);
      } else {
        sidebarToggled.update(sidebarToggled => true);
      }
    }
  }

  let sidebarState;

	sidebarToggled.subscribe((value) => {
		sidebarState = value;
	});

function getVideoLength() {
  let timeOutput = '';
    if(video.videoDuration) {
    let videoMinutes = video.videoDuration.minutes;
    let videoSeconds = video.videoDuration.seconds;
    timeOutput = videoMinutes+":"+('0' + videoSeconds).slice(-2)+" | ";
    
    }
    return timeOutput
}

function backtoVideo() {
    let section = document.getElementById('modalBody');
    section.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

</script>
<div bind:this={div}
  id={video.slug.current}
  in:fade="{{delay: 0,  duration: 200}}"
  on:click={update_video(video.slug.current), videoClicked, toggle_sidebar,backtoVideo}
  class="vec-relative vec-rounded-xl vec-mb-7 vec-p-3 vec-rounded-bl-none vec-bg-primary vec-flex vec-cursor-pointer">
  {#if !last}<div class="downline vec-absolute vec-top-[100%] vec-left-6 vec-w-[1px] vec-h-[calc(1.75rem)] vec-bg-midGrey/40" aria-hidden="true"></div>{/if}
  <div class="vec-relative vec-flex vec-rounded-full vec-w-6 vec-h-6 vec-bg-white/25 vec-flex-none">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="vec-m-auto vec-animate-spin">
      <path d="M7.8,20A9.954,9.954,0,0,1,0,16.243l1.561-1.25A8,8,0,1,0,7.8,2V0a10,10,0,1,1,0,20" transform="translate(2)" fill="#fff"/>
    </svg>
  </div>
  <div class="vec-text-black vec-pl-2">
    <div class=" vec-font-bold vec-pb-2">{video.videoTitle}</div>
    <div class="vec-text-xs vec-flex vec-items-center">
      <svg class="vec-mr-2 vec-opacity-25" xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
        <path  d="M14,12H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14a2,2,0,0,1,2,2v8a2,2,0,0,1-2,2M5.9,3h0V9l5.2-3Z" fill="#000" />
      </svg>
      {getVideoLength()}NOW WATCHING</div>
  </div>
</div>
